module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel14-f8667901651432db0e3cefe78382181c.jpg";